import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "disabled", "active", "focus", "tagName"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getColors = function getColors(scheme, active, disabled) {
  var isDarkView = scheme === 'dark' && !active || scheme === 'light' && active;
  if (disabled) {
    return {
      icon: scheme === 'light' ? 'disabled' : 'disabled-invert',
      closeIcon: scheme === 'light' ? 'disabled' : 'disabled-invert',
      title: scheme === 'dark' ? 'tertiary-invert' : 'tertiary',
      subTitle: scheme === 'dark' ? 'tertiary-invert' : 'tertiary'
    };
  }
  return {
    icon: isDarkView ? 'primary-invert' : 'primary',
    closeIcon: isDarkView ? 'tertiary-invert' : 'tertiary',
    title: isDarkView ? 'primary-invert' : 'primary',
    subTitle: isDarkView ? 'secondary-invert' : 'secondary'
  };
};
export var getBgColor = function getBgColor(scheme, active, disabled, invert) {
  if (disabled) {
    return scheme === 'dark' ? 'tertiary-invert' : 'tertiary';
  }
  if (active) {
    return scheme === 'dark' ? 'secondary' : 'secondary-invert';
  }
  if (invert) {
    return scheme === 'dark' ? 'tertiary-invert' : 'primary';
  }
  return scheme === 'dark' ? 'secondary-invert' : 'secondary';
};
export var getWrappedVariable = function getWrappedVariable(value, type) {
  return "var(--color-".concat(type, "-").concat(value, ")");
};
export var dataConverter = function dataConverter(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'light' : _ref$color,
    disabled = _ref.disabled,
    active = _ref.active,
    focus = _ref.focus,
    _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'button' : _ref$tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var activated = Boolean(active || focus);
  var colors = getColors(color, activated, disabled);
  return _objectSpread(_objectSpread({
    activated: activated,
    color: color,
    disabled: disabled,
    colors: colors,
    tagName: tagName
  }, tagName === 'button' ? {
    type: 'button',
    disabled: disabled
  } : {}), otherProps);
};